import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getCountries = createAsyncThunk("country/getCountries", async (payload) => {
  try {
    const response = await magnifiAPI.getCountries(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
